import { render, staticRenderFns } from "./Summary_Vertical.vue?vue&type=template&id=2c834fbe&scoped=true&"
import script from "./Summary_Vertical.vue?vue&type=script&lang=js&"
export * from "./Summary_Vertical.vue?vue&type=script&lang=js&"
import style0 from "./Summary_Vertical.vue?vue&type=style&index=0&id=2c834fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c834fbe",
  null
  
)

export default component.exports